"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortOrderEnum;
(function (SortOrderEnum) {
    SortOrderEnum["ASC"] = "ASC";
    SortOrderEnum["DESC"] = "DESC";
})(SortOrderEnum = exports.SortOrderEnum || (exports.SortOrderEnum = {}));
//# sourceMappingURL=index.js.map